import React, { Component} from "react";

import "./App.css";
import dataWorkCal25 from './2025_Work.json';
//import CalendarHeatmap from "react-calendar-heatmap";
import "react-calendar-heatmap/dist/styles.css";
//import {Tweet} from 'react-twitter-widgets';

// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/calendar
import { ResponsiveCalendar } from '@nivo/calendar'
/*import {calendarDefaultProps} from '@nivo/calendar'
import { isVisible } from "@testing-library/user-event/dist/utils";
import { generateDayCounts } from '@nivo/generators'
import string from "calendar-graph/lib/render/string";*/


// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.















   
class aCalendar extends Component {

  
 

   
  render() {

  

  // make sure parent container have a defined height when using
  // responsive component, otherwise height will be 0 and
  // no chart will be rendered.
  // website examples showcase many properties,
  // you'll often use just a few of them.
  const MyResponsiveCalendar = ({ data /* see data tab */ }) => (
      <ResponsiveCalendar
      data={dataWorkCal25}
      
        /*the color boundary is 159, there must be a larger value to preserve the scaling*/
          from="2025-01-02"
          to="2025-12-31"
          emptyColor="#eeeeee"
          /* 2024 coding note: 
          the color value in JSON for assistant is 1-79.
          the color value for electronics/coding/union activty is 80-129.
          the color value for A1/stagehand is 130 and above.
          leave empty for */
          colors={[ '#9be3bf', '#9be3bf', '#9be3bf','#DCC7BE', '#36bf7a' ]}
          margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
          monthSpacing={10} 
          isInteractive="false"
          tooltip={() => (<></>)}
        // onClick={(data) => this.hideComponent(data)}
          /*onMouseEnter={(data) => this.hideComponent(data)}
          
          /*tooltip={() => (<></>)}
          /*this works great! >>>>> onClick={() => this.hideComponent("showHideCal")}
          
         /*onClick={(data) => {babyPrinter(data.value)}}
          onClick={(data) => {Example(Number(data.value))}}
          onClick={(input) => {
            return(
            <div>
              {Example(Number(input))}
            </div>
            
            )}}*/
         /*tooltipFormat={value => Number(value).toLocaleString('en-US', {minimumFractionDigits: 2}) + '$'}*/
   
            /*
            return (
            <div style = {{
              position: 'absolute',}}>
              {mouseoverDecoder(input.value)}
            </div>
          )}} */
          yearSpacing={40}
          monthBorderColor="#ffffff"
          dayBorderWidth={2}
          dayBorderColor="#ffffff"
          legends={[
              {
                  anchor: 'bottom-right',
                  direction: 'row',
                  translateY: 36,
                  itemCount: 4,
                  itemWidth: 42,
                  itemHeight: 36,
                  itemsSpacing: 14,
                  itemDirection: 'right-to-left'
              }
          
          ]}
      />
  )
  

    return (
      <div className="App">


        

       
        
        <div className="map">
         <MyResponsiveCalendar/>
     
        
        </div>
        <div className="caption">
      
       
        </div>
        
        <div>
        </div>
    
       
      </div>
      
    );
  }
}

export default aCalendar;
